<template>
  <div class="colorations-games-content">
    <div class="colorations-games-content-inner">
      <img
        class="refresh"
        :src="require('@/assets/coloration/refresh.png')"
        alt=""
        @click="refresh()"
      />
      <div class="figure" id="zoneDrop">
        <img
          :src="require('@/assets/coloration/' + figureName + '.svg')"
          alt=""
        />

        <draggable
          v-for="(itemDrop, index) in itemsDrop"
          :key="index"
          :list="itemsPlaced[index]"
          item-key="id"
          class="round"
          :style="placeRoundOnFigure(itemDrop.x, itemDrop.y)"
          :id="index"
          group="sommets"
          :disabled="gameDone == true"
          @end="onDrop"
        >
          <template #item="{ element }">
            <div
              :id="element.id"
              :class="'round is-placed bg-' + element.color"
            ></div>
          </template>
        </draggable>
      </div>

      <draggable
        class="sommets"
        :list="itemsDrag"
        item-key="id"
        group="sommets"
        @end="onDrop"
        :disabled="gameDone == true"
      >
        <template #item="{ element }">
          <div :id="element.id" :class="'round bg-' + element.color"></div>
        </template>
      </draggable>
    </div>

    <ActionsGames
      @verification="verification()"
      @showResponse="showResponse()"
      see-response-text="Voir l'une des solutions"
      :message="message"
      :gameDone="gameDone"
    />
  </div>
</template>

<script>
import ActionsGames from "../layout/ActionsGames";
import _ from "lodash";
import draggable from "vuedraggable";

export default {
  name: "Figure",
  components: {
    ActionsGames,
    draggable,
  },
  props: {
    currentFigure: {},
    figure: Object,
  },
  data: function () {
    return {
      itemsPlaced: [],
      message: "",
      itemsDrag: [],
      itemsDrop: [],
      solution: [],
      gameDone: false,
      figureName: "",
    };
  },
  created() {
    this.init();
  },
  watch: {
    currentFigure: function () {
      this.itemsPlaced = [];
      this.message = "";
      this.init();
    },
  },
  methods: {
    init() {
      /** New figure */
      this.itemsDrag = _.cloneDeep(this.currentFigure.itemsDrag);
      this.itemsDrop = _.cloneDeep(this.currentFigure.itemsDrop);
      this.solution = _.cloneDeep(this.currentFigure.solution);
      this.figureName = this.currentFigure.name.toLowerCase().replace(/ /g, "");
      this.gameDone = false;
      for (var index in this.itemsDrag) {
        this.itemsPlaced[index] = [];
      }
    },
    placeRoundOnFigure(x, y) {
      return "top:" + x + "%;left:" + y + "%;";
    },
    onDrop(event) {
      if (event.to.id != '') {
        if (this.itemsPlaced[event.to.id].length != 1) {
          let positionNewItem = this.itemsPlaced[event.to.id].findIndex((element) => element.id == event.item.id)
          let positionOldItem = (positionNewItem) == 1 ? 0 : 1
          // delete old item
          this.itemsDrag.push(this.itemsPlaced[event.to.id][positionOldItem])
          //push old item to dragItem bar
          this.itemsPlaced[event.to.id].splice(positionOldItem,1);
          
        } else {
          this.itemsPlaced[event.to.id].links = this.itemsDrop[event.to.id].links;
          this.itemsPlaced[event.to.id].color = this.currentFigure.itemsDrag[event.item.id].color;
        }
      }
    },
    refresh() {
      this.$emit("init", { param: this.figureName });
      this.itemsPlaced = [];
      this.message = "";
      this.init();
    },
    verification() {
      this.gameDone = true;

      for (let item of this.itemsPlaced) {
        //if there are something in the item
        if (item.length != 0) {
          //verif if link are same color
          for (let link of item.links) {
            if (this.itemsPlaced[link].color == item.color) {
              return (this.message =
                "<h2>Oups, dommage...</h2><h3>Retentez votre chance !</h3>");
            }
          }
        } else {
          return (this.message =
            "<h2>Oups, dommage...</h2><h3>Retentez votre chance !</h3>");
        }
      }
      return (this.message =
        "<h2>Bravo, bonne réponse !</h2><h3>Rejouez avec une autre figure !</h3>");
    },
    showResponse() {
      this.gameDone = true;

      for (const index in this.solution) {
        this.itemsPlaced[index] = [this.solution[index]];
      }

      this.itemsDrag = _.cloneDeep(this.currentFigure.itemsDrag);
      for (const item of this.itemsDrag) {
        item.color = "white";
      }

      this.message =
        "<h2>Petit joueur...</h2><h3>Retentez votre chance avec une autre figure !</h3>";

    },
  },
};
</script>

<style lang="scss">
.colorations-games-content {
  &-inner {
    height: 30rem;
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 19rem;
    }
    .refresh {
      width: 1.5rem;
      align-self: flex-end;
      padding: 0.5rem;
      border-left: 1px solid #000;
      border-bottom: 1px solid #000;
      cursor: pointer;
    }
    .figure {
      position: relative;
      margin: auto;
      .round {
        position: absolute;
        transform: translate(-50%, -50%);
        background-color: #fff;
      }
    }
    .sommets {
      height: 25%;
      border-top: 1px solid #000;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
    }
    .round {
      width: 32.5px;
      height: 32px;
      border: 5px solid #000;
      border-radius: 50px;
      &.bg-red {
        background-color: rgb(224, 87, 87);
      }
      &.bg-darkBlue {
        background-color: blue;
      }
      &.bg-lightGreen {
        background-color: rgb(110, 233, 186);
      }
      &.bg-black {
        background-color: #000;
      }
      &:not(:last-child) {
        margin-right: 1rem;
      }
      .round {
        transform: translate(-5px, -5px) !important;
      }
      @media (max-width: 1200px) {
        width: 28px;
        height: 28px;
      }
    }
  }
  .actions {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    .link {
      color: grey;
      cursor: pointer;
      text-decoration: underline;
      font-size: 0.8rem;
      margin-left: 2rem;
      align-self: center;
    }
    .btn {
      cursor: pointer;
      padding: 1rem 3rem;
      &-black {
        background-color: #000;
        color: white;
        text-transform: uppercase;
      }
    }
  }
}

.message {
  h2 {
    font-size: 2rem;
  }
}
</style>